export default {
      id: "ic_tribun_share_modal-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_share_modal-usage",
      toString: function () {
        return this.url;
      }
    }